const currency = (value, { hideSymbol } = { hideSymbol: false }) => {
  const formatted = parseFloat(value).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })

  if (hideSymbol) {
    return formatted.substr(3)
  }

  return formatted
}

export default currency
